import { IOrderState } from '@/store/types';

const state: IOrderState = {
  orders: [],
  searchQuery: '',
  ordersDetailed: {},
  ordersValidationContext: {},
  orderProductsMap: {
    // '6': '1:10,2:4,3:5'
  },
  queue: [],
  nextPossibleUpdateTime: (new Date()).getTime(),
};

export default state;